import {Fragment, observer, React} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {PermDataSetting} from '@material-ui/icons'
import {ContextMenuItem, openInNewTab, useAssortmentCardStore, useAssortmentHeroCardStore, useBuilderCardStore, useCatalogItemsListStore, useGroupByGroupStore, useHeroCardSecondLevelStore} from '@modules'
import {nav, ui, useCatalog} from '@stores'
import {useCatalogRootFlexLayoutStore, useVipFlexLayoutTabStore} from '@stores/catalog/flexLayout'
import {icons} from '@stores/ui'
import * as css from './DevCatalogContextMenuItems.css'

export const DevCatalogContextMenuItems = observer(function DevCatalogContextMenuItems() {
  const groupByStore = useGroupByGroupStore(),
    builderCardStore = useBuilderCardStore(),
    catalogItemsSidebar = useCatalogItemsListStore(),
    catalog = useCatalog(),
    flexTab = useVipFlexLayoutTabStore(),
    catalogTabRoot = useCatalogRootFlexLayoutStore(),
    assortmentCard = useAssortmentCardStore(),
    assortmentHero = useAssortmentHeroCardStore(),
    assortmentSecondLevel = useHeroCardSecondLevelStore(),
    {filter, stores: {flexLayout: {activeCatalogRoot}}} = catalog

  if (!DEBUG) return null

  const assortmentMenuItems = assortmentCard && <Fragment>
	  <MenuDivider/>
	  <ContextMenuItem text='Assortment Root Query' onClick={assortmentCard.root.copyQueryToClipboard}/>
	  <ContextMenuItem text='Copy Assortment Store to Window' onClick={assortmentCard.onCopyStoreToWindow}/>
    {assortmentHero && <ContextMenuItem text='Copy Hero Store to Window' onClick={assortmentHero.onCopyStoreToWindow}/>}
    {assortmentSecondLevel && <ContextMenuItem text='Copy 2nd Level Item Store to Window' onClick={assortmentSecondLevel.onCopyStoreToWindow}/>}
	  <ContextMenuItem text='Assortment Card Query' onClick={assortmentCard.copyQueryToClipboard}/>
  </Fragment>

  return <ContextMenuItem className={css.root} dividerBefore icon={icons.dev} text='Developer-Only'>
    {flexTab?.node && <ContextMenuItem dividerAfter text={`Tab ${flexTab.node.id}`} icon='clipboard' onClick={() => navigator.clipboard.writeText(`flexLayout.model.getNodeById('${flexTab.node.id}')`)} />}
    {catalogTabRoot?.node && <ContextMenuItem dividerAfter text={`Catalog Tab ${catalogTabRoot.node.id}`} icon='clipboard' onClick={() => navigator.clipboard.writeText(`stores['${catalogTabRoot.stores.storeId}']`)}/>}
    {/*<ToggleLocalCantaloupeServerMenuItem />*/}
    <MenuDivider />
    <ContextMenuItem text='Open VIP SaaS Kibana' icon='database' shouldDismissPopover onClick={() => openInNewTab(VIP_ES_KIBANA_URL)}/>
    <ContextMenuItem text='Open in Kibana' icon='database' shouldDismissPopover onClick={() => openInNewTab(nav.kibanaUrl)}/>

    <ContextMenuItem text='Kibana Queries' icon='clipboard'>
    <ContextMenuItem text='Catalog Cards Query' icon={<PermDataSetting/>} onClick={() => navigator.clipboard.writeText(`GET ${catalog.index}/_search\n${JSON.stringify(catalog.queryVariablesEs, null, 1)}`)}/>
      <ContextMenuItem text='Filter Query' icon={icons.filter} onClick={() => navigator.clipboard.writeText(`GET ${catalog.index}/_search\n${JSON.stringify(filter.refetchBody, null, 1)}`)}/>
      {activeCatalogRoot?.stores?.sidebar?.left?.catalogLibraries && <ContextMenuItem text='Libraries Query' icon={icons.library} onClick={() => navigator.clipboard.writeText(`GET _search\n${JSON.stringify(activeCatalogRoot.stores.sidebar.left.catalogLibraries?.searchPayload, null, 1)}`)}/>}
      <ContextMenuItem text='Group By Counts' icon={<PermDataSetting/>} onClick={() => navigator.clipboard.writeText(`GET ${catalog.index}/_search\n${JSON.stringify(catalog.groupBy.countsSearchClause, null, 1)}`)}/>
    {groupByStore && <Fragment>
    <MenuDivider />
	      <ContextMenuItem text='Copy Root Group By Query to Clipboard' onClick={groupByStore.onCopyGroupByRootQueryToClipboard}/>
        <ContextMenuItem text='Copy Specific Group Query to Clipboard' onClick={groupByStore.onCopyGroupByQueryToClipboard} />
        <ContextMenuItem text='Copy Group Store to Window' onClick={groupByStore.onCopyStoreToWindow} />
    </Fragment>}

      {catalogItemsSidebar && <Fragment>
	      <MenuDivider/>
	      <ContextMenuItem text='Copy Catalog Items Sidebar Query to Clipboard' onClick={catalogItemsSidebar.copyDocQueryToClipboard}/>
      </Fragment>}
    {builderCardStore && <Fragment>
	    <MenuDivider/>
	    <ContextMenuItem text='Copy Product _doc Query to Clipboard' onClick={builderCardStore.copyDocQueryToClipboard}/>
    </Fragment>}

      {assortmentMenuItems}

    </ContextMenuItem>
    {assortmentMenuItems}

    {flexTab?.tab?.extraData?.store && <ContextMenuItem text='Copy tab extra store to Window' onClick={flexTab.tab.onCopyExtraStoreToWindow}/>}
      {/*<MenuDivider />*/}
    {/*<ContextMenuItem text='Catalog Libraries New Look' active={ui.settings.newCatalogLibrariesLook === true} onClick={e => ui.settings.newCatalogLibrariesLook = !ui.settings.newCatalogLibrariesLook}  />*/}
  </ContextMenuItem>
})


// export const UseC8ImageServerMenuItem = observer(function UseC8ImageServerMenuItem() {
//   const {settings} = ui
//   return (
//     DEBUG ? <ContextMenuItem text='Use C8 instead of Cantaloupe?' icon={settings.imageSource !== 'c8' ? 'blank' : 'tick'} onClick={() => settings.imageSource = settings.imageSource === 'c8' ? null : 'c8'}/> : null
//   )
// })



// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/DevCatalogContextMenuItems.tsx